import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { TriangleAlert } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useCompaniesLimit } from '@/features/team/queries'

export function CompaniesLimitBanner() {
  const { t } = useTranslation()
  const { reached, max, count } = useCompaniesLimit()
  if (!reached) return null

  return (
    <div role="alert" className="flex flex-wrap items-center gap-x-4 gap-y-2 border-b border-destructive/25 bg-destructive/8 px-4 py-2.5 text-sm md:px-6">
      <TriangleAlert className="size-4 shrink-0 text-destructive" />
      <p className="min-w-0 flex-1">
        <span className="font-medium">{t('companies.list.limitBanner.title')}. </span>
        <span className="text-muted-foreground">{t('companies.list.limitBanner.message', { current: count, max })}</span>
      </p>
      <Button size="sm" variant="outline" asChild>
        <Link to="/settings/subscription">{t('companies.list.limitBanner.upgrade')}</Link>
      </Button>
    </div>
  )
}
